import { configureStore } from "@reduxjs/toolkit";
import categoryReducer from "src/store/category";
import tabReducer from "src/store/tab"
import mainReducer from "src/store/mainStore"
import sessionReducer from "src/store/sessionStore"
import storageSession from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";

const persistConfig = {
  key: "session",
  storage: storageSession,
  whitelist: ["serviceType", "stockName"],
};

const persistedSessionReducer = persistReducer(persistConfig, sessionReducer);

const store = configureStore({
  reducer: {
    category: categoryReducer,
    tab: tabReducer,
    main: mainReducer,
    session: persistedSessionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REGISTER"],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

export default store;
